// Shared role semantics helpers
// NOTE: This is frontend-only semantics alignment with Firestore rules.

/**
 * Returns true if the given role should be treated as an admin-equivalent
 * in the UI. Firestore rules already treat owner and admin the same:
 *   isAdmin(companyId) = role === 'owner' || role === 'admin'
 */
export function isAdminLike(role) {
  return role === 'admin' || role === 'owner';
}
